module.exports = __webpack_public_path__ + "execute-octopus-server-roles.11234407f0fdf17b59db872a58225dca.hashedasset.svg";